import { DisplayObject } from '@pixi/display';
import { Point } from '@pixi/core';
DisplayObject.prototype.getGlobalPosition = function getGlobalPosition() {
  var point = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Point();
  var skipUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (this.parent) {
    this.parent.toGlobal(this.position, point, skipUpdate);
  } else {
    point.x = this.position.x;
    point.y = this.position.y;
  }
  return point;
};